import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SystemSettings } from '../../types';

// 默认系统设置
const defaultSettings: SystemSettings = {
  siteName: '悠米宝贝宠物管理平台',
  // logo: '/api/v1/admin/logo.png',
  logo: 'https://data.cnmm.cc/20260430163801_6baeaa11.png',
  version: '1.0.0',
  maintenance: false,
  announcement: '悠米宝贝宠物管理平台',
};

// 状态接口
interface SettingsState {
  settings: SystemSettings;
  theme: 'light' | 'dark';
  sidebarCollapsed: boolean;
  pageSize: number;
  autoRefresh: boolean;
  refreshInterval: number; // 秒
}

// 初始状态
const initialState: SettingsState = {
  settings: defaultSettings,
  theme: 'light',
  sidebarCollapsed: false,
  pageSize: 10,
  autoRefresh: false,
  refreshInterval: 30,
};

// 创建slice
const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    // 更新系统设置
    updateSettings: (state, action: PayloadAction<Partial<SystemSettings>>) => {
      state.settings = { ...state.settings, ...action.payload };
    },
    // 切换主题
    toggleTheme: (state) => {
      state.theme = state.theme === 'light' ? 'dark' : 'light';
    },
    // 切换侧边栏折叠状态
    toggleSidebar: (state) => {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    // 设置侧边栏折叠状态
    setSidebarCollapsed: (state, action: PayloadAction<boolean>) => {
      state.sidebarCollapsed = action.payload;
    },
    // 设置分页大小
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    // 切换自动刷新
    toggleAutoRefresh: (state) => {
      state.autoRefresh = !state.autoRefresh;
    },
    // 设置自动刷新状态
    setAutoRefresh: (state, action: PayloadAction<boolean>) => {
      state.autoRefresh = action.payload;
    },
    // 设置刷新间隔
    setRefreshInterval: (state, action: PayloadAction<number>) => {
      state.refreshInterval = action.payload;
    },
    // 重置设置
    resetSettings: (state) => {
      state.settings = defaultSettings;
      state.theme = 'light';
      state.sidebarCollapsed = false;
      state.pageSize = 10;
      state.autoRefresh = false;
      state.refreshInterval = 30;
    },
  },
});

export const {
  updateSettings,
  toggleTheme,
  toggleSidebar,
  setSidebarCollapsed,
  setPageSize,
  toggleAutoRefresh,
  setAutoRefresh,
  setRefreshInterval,
  resetSettings,
} = settingsSlice.actions;

export default settingsSlice.reducer;
